import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import moment from 'moment';

import { AppFieldBox, AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { shiftCreate, shiftDetail } from 'bus/shift/actions';
import { ShiftCreate } from 'bus/shift/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

import { SchedulerCalendar } from './components';

type Props = {
  visible: boolean;
  currentDate: string;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: ShiftCreate = {
  employeeId: null,
  date: new Date().toString(),
  dates: [],
};

const CreateEditModal: FC<Props> = ({ changeVisible, refresh, visible, id, currentDate }) => {
  const dispatch = useDispatchPromise();
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const employeeDateSource = useMemo(() => {
    const defaultFilter = [
      ['isResident', '=', 'true'],
      'and',
      ['!', [['postId', '=', 1], 'or', ['postId', '=', 3], 'or', ['postId', '=', 2]]],
    ];
    const defaultSort = [{ selector: 'surname', desc: false }];
    return $createDataSource('/v1/employee', 'id', { defaultFilter, defaultSort });
  }, []);

  const [form, setForm] = useState<ShiftCreate>(initialForm);

  const disabledSubmit = false;

  const onShown = async () => {
    if (id) {
      const result = await dispatch(shiftDetail.async({ employeeId: id, date: currentDate }));
      setForm((prev) => ({ ...prev, dates: result, date: currentDate, employeeId: id }));
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const changeEmployeeHandler = async (e: any) => {
    const result: any = await dispatch(
      shiftDetail.async({ employeeId: e.itemData.id, date: moment(form.date).format('YYYY-MM-DD[T]HH:mm:ss.SSS') }),
    );
    setForm((prev) => ({ ...prev, employeeId: e.itemData.id, dates: result }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await dispatch(shiftCreate.async({ ...form, date: moment(form.date).format('YYYY-MM-DD[T]HH:mm:ss.SSS') }));
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Смены сотрудника"
        width={400}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="form-edit-create" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFieldBox label="Сотрудник" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={employeeDateSource}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.employeeId}
                            searchEnabled
                            searchExpr="fullName"
                            readOnly={!!id}
                            onItemClick={changeEmployeeHandler}
                          >
                            <DropDownOptions title="Выберите сотрудника" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите сотрудника" />
                            </Validator>
                          </SelectBox>
                        </AppFieldBox>

                        <AppFiledBox label="Период" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, date: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.date}
                            calendarOptions={{
                              maxZoomLevel: 'year',
                              minZoomLevel: 'century',
                            }}
                            displayFormat="monthAndYear"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле период" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <div className="d-flex justify-center">
                          <SchedulerCalendar
                            currentDate={form.date}
                            onChange={(dates) => setForm((prev) => ({ ...prev, dates }))}
                            value={form.dates}
                          />
                        </div>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
